function searchForm() {
  return {
    query: '',
    open: false,
  };
}

window.searchForm = searchForm;
